import { publish } from 'ert-framebus';
import { PubSubMessages } from '../config';
import { AppenderIdentifier, LogAppender, LogAppenderFactory,
         loggerFactory, LogRecord, Logger } from 'ert-logger';

export class FramebusAppender implements LogAppender {

    append(record: LogRecord) {
        publish(PubSubMessages.log, record);
    }
}

export class FramebusAppenderFactory implements LogAppenderFactory {
    appenderId: string = 'framebus';

    create(): LogAppender {
        return new FramebusAppender();
    }
}

loggerFactory.config({
    appenders: [{
        appenderId: 'framebus' as AppenderIdentifier,
        config: undefined
    }]
});

loggerFactory.addAppenderFactory(new FramebusAppenderFactory());

/**
 * Wrap an object with the Logger
 * @param object 
 * @param logger 
 */
export function wrapWithLogger<T extends { [key: string]: Function | any }>(object: T, logger: Logger): T {
    for (const key of Object.keys(object)) {
        const objectAttribute = object[key];
        // attribute a function?
        if (typeof objectAttribute === 'function') {
            wrapOneFunctionWithLogger(object, key, logger);
        // attribute an object?
        } else if (typeof objectAttribute === 'object') {
            wrapWithLogger(objectAttribute, logger);
        }
    }
    return object;
}

/**
 * Wrap a fuction with the logger
 * @param object 
 * @param key 
 * @param logger 
 */
function wrapOneFunctionWithLogger(object: any, key: string, logger: Logger): void {
    const func = object[key];
    object[key] = (...args: any[]): any => {
        try {
            const result = func(...args);
            return result && typeof result.then === 'function' ? result.catch((e: Error) => {
                logger.error(e);
            }) : result;
        } catch (e) {
            logger.error(e);
        }
    };
}
